
import PropTypes from 'prop-types'
import React from 'react'

import './styles.scss'

import { MaterialDeleteButton } from '../../material-delete-button'

export class Toast extends React.Component {
  render () {
    const { children } = this.props
    return (
      <div
        key='toast'
        className='nh-toast w-full'
      >
        <div className='nh-toast-content'>{children}</div>
        <div className='nh-toast-actions flex-shrink-0'>
          <MaterialDeleteButton
            inTable={false}
            onClick={() => this.props?.onDelete?.()}
            title='Delete'
          />
        </div>
      </div>
    )
  }
}

Toast.propTypes = {
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      display: PropTypes.string,
      action: PropTypes.func
    })
  ),
  borderColor: PropTypes.string
}
